<template>
    <div class="container single_page">
        <div class="row" v-if="data.text">
            <p v-html="data.text">{{ data.text }}</p>
        </div>
        <div class="row" v-else>
            <p>Loading ...</p>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            data: [],
            errors: []
        }
    },

    // Fetches posts when the component is created.
    created() {
        var authOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            url: 'http://www.clun-forest.sk/cockpit/api/singletons/get/about?token=715b9f9a9f192319672a7a842fc494',
            json: true
        };
        axios(authOptions)
        .then(response => {
            this.data = response.data;
            console.log(this.data);            
        })
        .catch(e => {
            this.errors.push(e)
        })
    }
}
</script>


// WEBPACK FOOTER //
// src/components/About.vue